import React, { useState, useEffect, Suspense } from "react";
import "aos/dist/aos.css";
import { toast } from "react-toastify";
import axios from "axios";
// import Footer from "../../components/footer";
import rule from "../../assets/rule.webp";
import ruleMobile from "../../assets/rulemb.webp";
// import PromotionModal1 from "../../components/promotionModal1";
import ListPromotionModal from "../../components/listPromotionModal";
import LoadingApply from "../../components/loadingApply";
import CryptoJS from "crypto-js";
// import Header from '../../components/header';
import bannerTitle from "../../assets/homepage/banner-title.png";
import mainLogoGif from "../../assets/header/main-logo.gif";
import bgMobile from "../../assets/homepage/body/background-mb.png";
import iconUser from "../../assets/homepage/body/user.png";
import iconTick from "../../assets/homepage/body/tick.png";

// Import cÃ¡c component má»›i Ä‘Ã£ phÃ¢n tÃ¡ch
import BannerTitle from "../../components/HomePage/BannerTitle";
import RegistrationForm from "../../components/HomePage/RegistrationForm";
import PromotionTabs from "../../components/HomePage/PromotionTabs";
import FloatButton from "../../components/FloatButton";
import { FiX } from "react-icons/fi";

const CRITICAL_ASSETS = [
  rule,
  ruleMobile,
  bannerTitle,
  mainLogoGif,
  iconUser,
  iconTick,
  bgMobile,
];

const SETTING_PUBLIC_MOCK = [
  { key: "image:gif-1", value: "" },
  { key: "link:gif-1-mb", value: "" },
  { key: "link:gif-1-pc", value: "" },
  { key: "image:gif-2", value: "" },
  { key: "link:gif-2-mb", value: "" },
  { key: "link:gif-2-pc", value: "" },
  { key: "title:notify", value: "" },
];

const getConfigValue = (config, keys) => {
  const keyList = Array.isArray(keys) ? keys : [keys];
  return keyList
    .map((key) => config.find((item) => item.key === key)?.value)
    .find(Boolean);
};

const normalizeSettingPublicConfig = (settings = []) => {
  const mergedSettings = [...settings];

  SETTING_PUBLIC_MOCK.forEach((mockItem) => {
    if (!mergedSettings.some((item) => item.key === mockItem.key)) {
      mergedSettings.push(mockItem);
    }
  });

  return mergedSettings;
};

const HomePage = () => {
  const [activeButton, setActiveButton] = useState("promotions");
  const [username, setUsername] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const [captchaSvg, setCaptchaSvg] = useState("");
  const [promotions, setPromotions] = useState(null);
  const [listPromotions, setListPromotions] = useState(null);
  const [promotionsMB, setPromotionsMB] = useState(null);
  const [promotion, setPromotion] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openListPromotionModal, setOpenListPromotionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingApply, setLoadingApply] = useState(false);
  const [visibleCount, setVisibleCount] = useState(4);
  const [loadedImages, setLoadedImages] = useState({});
  const [showForbiddenModal, setShowForbiddenModal] = useState(false);
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const [config, setConfig] = useState([]);
  const [showSwiper, setShowSwiper] = useState(true);
  const [showLeftWidget, setShowLeftWidget] = useState(true);
  const [showRightWidget, setShowRightWidget] = useState(true);

  const secretKey = "RR882024RR88";

  useEffect(() => {
    fetchCaptcha();
    fetchPromotionMB();
    fetchPromotion();
    fetchSetting();
    setLoading(true);
  }, []);

  const fetchCaptcha = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/captcha`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      if (data.statusCode === 200) {
        setCaptchaId(data.data.captchaId);
        setCaptchaSvg(data.data.captcha);
      } else {
        toast.error("Không thể tải Captcha");
      }
    } catch (error) {
      toast.error("Lỗi tải Captcha");
    }
  };

  const fetchSetting = async () => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => setLoading(false), 3000);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/setting-public`
      );
      setLoading(false);
      setConfig(normalizeSettingPublicConfig(response.data));
      clearTimeout(loadingTimeout);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      setConfig(SETTING_PUBLIC_MOCK);
      clearTimeout(loadingTimeout);
    }
  };

  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  };

  useEffect(() => {
    const preloadAssets = async () => {
      try {
        const imagePromises = CRITICAL_ASSETS.map((src) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
            img.onerror = resolve;
          });
        });

        await Promise.all([
          Promise.all(imagePromises),
          new Promise((resolve) => setTimeout(resolve, 1500)),
        ]);

        setAssetsLoaded(true);
      } catch (e) {
        console.error("Asset preloading failed", e);
        setAssetsLoaded(true);
      }
    };

    preloadAssets();
  }, []);

  const fetchPromotion = async () => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => setLoading(false), 3000);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/promotion`);
      setPromotions(response.data.data.promotion);
      setLoading(false);
      clearTimeout(loadingTimeout);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchPromotionMB = async () => {
    const loadingTimeout = setTimeout(() => setLoading(false), 3000);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/promotion?platform=M`
      );
      setPromotionsMB(response.data.data.promotion);
      setLoading(false);
      clearTimeout(loadingTimeout);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const checkUsername = async () => {
    if (!username.trim() || !captcha.trim()) {
      toast.warn("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    try {
      setLoadingApply(true);
      const fingerprint = sessionStorage.getItem("fp");
      const encryptedPayload = encryptData({
        username: username.toLowerCase(),
        captcha,
        captchaId,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/promotion/check`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Fingerprint": fingerprint,
          },
          body: JSON.stringify({ data: encryptedPayload }),
        }
      );

      const data = await response.json();
      if (data.statusCode === 200) {
        setOpenListPromotionModal(true);
        setListPromotions(data.data.promotions);
      } else if (data.statusCode === 403) {
        setShowForbiddenModal(true);
      } else {
        toast.error(data?.message || "Có lỗi xảy ra!");
      }
      fetchCaptcha();
      setLoadingApply(false);
    } catch (error) {
      toast.error("Có lỗi xảy ra khi kiểm tra tài khoản");
    }
  };

  const clickPromotion = (promotion) => {
    setPromotion(promotion);
    setOpenModal(true);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const leftImage = getConfigValue(config, ["image:gif-1", "image:gif-left"]);
  const rightImage = getConfigValue(config, ["image:gif-2", "image:gif-right"]);

  const leftLink = isMobile
    ? getConfigValue(config, ["link:gif-1-mb", "link:gif-left-mb"]) ||
      getConfigValue(config, ["link:gif-1-pc", "link:gif-left-pc"])
    : getConfigValue(config, ["link:gif-1-pc", "link:gif-left-pc"]);

  const rightLink = isMobile
    ? getConfigValue(config, ["link:gif-2-mb", "link:gif-right-mb"]) ||
      getConfigValue(config, ["link:gif-2-pc", "link:gif-right-pc"])
    : getConfigValue(config, ["link:gif-2-pc", "link:gif-right-pc"]);

  const appReady = assetsLoaded && (!loading || (promotions && promotionsMB));

  if (!appReady) {
    return (
      <div className="fixed inset-0 bg-[#050B21] flex flex-col items-center justify-center z-[9999]">
        <div className="relative w-32 h-32">
          <div className="absolute inset-0 border-4 border-[#00E5FF]/20 rounded-full" />
          <div className="absolute inset-0 border-4 border-t-[#00E5FF] rounded-full animate-spin" />
        </div>
        <p className="mt-8 text-[#00E5FF] font-bold text-lg animate-pulse">
         Đang tải ...
        </p>
      </div>
    );
  }

  return (
    <>
      {loadingApply && <LoadingApply />}
      {/* 
      <Header /> */}

      <main
        className={`min-h-screen flex flex-col w-full overflow-x-hidden ${
          activeButton === "conditions" ? "conditions-bg" : "homepage-bg"
        }`}
        style={
          isMobile
            ? {
                backgroundImage: `url(${bgMobile})`,
                backgroundPosition: "center -90px",
                backgroundSize: "cover",
              }
            : {}
        }
      >
        <section className="w-full pb-3 flex flex-col items-center">
          <div className="w-full max-w-[1280px] mx-auto flex flex-col items-center">
            <BannerTitle />
            <div className="w-full px-3 md:px-0">
              <div className="hidden lg:grid lg:grid-cols-2 items-start">
                <RegistrationForm
                  username={username}
                  setUsername={setUsername}
                  captcha={captcha}
                  setCaptcha={setCaptcha}
                  captchaSvg={captchaSvg}
                  fetchCaptcha={fetchCaptcha}
                  checkUsername={checkUsername}
                  titleNotify={config.find((c) => c.key === "title:notify")?.value}
                />
                <PromotionTabs
                  activeButton={activeButton}
                  setActiveButton={setActiveButton}
                  promotions={promotions}
                  promotionsMB={promotionsMB}
                  visibleCount={visibleCount}
                  loadMore={() => setVisibleCount((prev) => prev + 99)}
                  loadedImages={loadedImages}
                  handleImageLoad={(id) =>
                    setLoadedImages((prev) => ({ ...prev, [id]: true }))
                  }
                  clickPromotion={clickPromotion}
                  rule={rule}
                  ruleMobile={ruleMobile}
                  showTabs={false}
                  forceSection="promotions"
                  previewLimit={6}
                  enableShowMore={false}
                  forceScrollable={true}
                  scrollMaxHeightClass="md:max-h-[440px]"
                />
              </div>

              <div className="lg:hidden w-full flex flex-col items-center">
                <RegistrationForm
                  username={username}
                  setUsername={setUsername}
                  captcha={captcha}
                  setCaptcha={setCaptcha}
                  captchaSvg={captchaSvg}
                  fetchCaptcha={fetchCaptcha}
                  checkUsername={checkUsername}
                  titleNotify={config.find((c) => c.key === "title:notify")?.value}
                />
                <div className="w-full mt-3">
                  <PromotionTabs
                    activeButton="promotions"
                    setActiveButton={setActiveButton}
                    promotions={promotions}
                    promotionsMB={promotionsMB}
                    visibleCount={visibleCount}
                    loadMore={() => setVisibleCount((prev) => prev + 99)}
                    loadedImages={loadedImages}
                    handleImageLoad={(id) =>
                      setLoadedImages((prev) => ({ ...prev, [id]: true }))
                    }
                    clickPromotion={clickPromotion}
                    rule={rule}
                    ruleMobile={ruleMobile}
                    showTabs={false}
                    forceSection="promotions"
                    previewLimit={6}
                    enableShowMore={false}
                    forceScrollable={true}
                    scrollMaxHeightClass="md:max-h-[440px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="w-full flex flex-col items-center min-h-[60vh] pb-6">
          <div className="w-full max-w-[1280px] mx-auto flex flex-col items-center">
            <PromotionTabs
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              promotions={promotions}
              promotionsMB={promotionsMB}
              visibleCount={visibleCount}
              loadMore={() => setVisibleCount((prev) => prev + 99)}
              loadedImages={loadedImages}
              handleImageLoad={(id) =>
                setLoadedImages((prev) => ({ ...prev, [id]: true }))
              }
              clickPromotion={clickPromotion}
              rule={rule}
              ruleMobile={ruleMobile}
              hidePromotionsContent={!isMobile}
            />
          </div>
        </section> */}
      </main>

      {/* <Footer /> */}

      {/* <PromotionModal1
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        promotion={promotion}
      /> */}
      <ListPromotionModal
        isOpen={openListPromotionModal}
        onClose={() => setOpenListPromotionModal(false)}
        promotions={listPromotions}
        username={username}
      />

      {showForbiddenModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[100]">
          <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 sm:w-96">
            <h2 className="text-lg font-bold text-red-600 text-center uppercase">
              Tài khoản không được tham gia khuyến mãi
            </h2>
            <p className="text-sm text-gray-700 text-center mt-2">
              Vui lòng liên hệ CSKH 24/7 để được hỗ trợ.
            </p>
            <div className="mt-4 text-center">
              <a
                href="https://llwin-cskh.pages.dev"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 font-semibold hover:underline"
              >
                https://llwin-cskh.pages.dev
              </a>
            </div>
            <div className="mt-4 flex justify-center">
              <button
                onClick={() => setShowForbiddenModal(false)}
                className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg"
              >
                Đóng
              </button>
            </div>
          </div>
        </div>
      )}

      {showSwiper && config.find((c) => c.key === "image:gif")?.value && (
        <div className="fixed top-1/2 right-0 -translate-y-1/2 z-50 bg-transparent pr-2">
          <button
            className="absolute -top-3 -left-3 bg-[#000000cc] text-white rounded-full w-7 h-7 flex items-center justify-center text-lg"
            onClick={() => setShowSwiper(false)}
          >
            Ã—
          </button>

          <div className="max-w-[200px]">
            <a
              href={config.find((c) => c.key === "link:gif")?.value || "#"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={config.find((c) => c.key === "image:gif")?.value || ""}
                alt="Floating promotion"
                className="rounded-lg w-full"
              />
            </a>
          </div>
        </div>
      )}

      {showLeftWidget && leftImage && (
        <FloatButton
          variant="image"
          position="bottom-right"
          href={leftLink}
          target="_blank"
          icon={
            <div className="flex flex-col items-center relative group">
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setShowLeftWidget(false);
                }}
                className="absolute -top-4 -right-4 w-7 h-7 bg-white border border-gray-300 rounded-full flex items-center justify-center text-gray-500 hover:text-red-500 cursor-pointer z-[100000] shadow-md transition-all active:scale-95 hover:bg-gray-50 hover:border-red-300"
              >
                <FiX className="w-5 h-5" />
              </div>
              <img
                src={leftImage}
                alt="Widget Left"
                draggable={false}
                className="w-20 h-20 md:w-44 md:h-44 object-contain drop-shadow-lg select-none"
              />
            </div>
          }
          className="shadow-none bg-transparent hover:shadow-none bottom-[30%] md:bottom-[31%] select-none"
          draggable
        />
      )}

      {showRightWidget && rightImage && (
        <FloatButton
          variant="image"
          position="bottom-right"
          href={rightLink}
          target="_blank"
          icon={
            <div className="flex flex-col items-center relative group">
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setShowRightWidget(false);
                }}
                className="absolute -top-4 -right-4 w-7 h-7 bg-white border border-gray-300 rounded-full flex items-center justify-center text-gray-500 hover:text-red-500 cursor-pointer z-[100000] shadow-md transition-all active:scale-95 hover:bg-gray-50 hover:border-red-300"
              >
                <FiX className="w-5 h-5" />
              </div>
              <img
                src={rightImage}
                alt="Widget Right"
                draggable={false}
                className="w-20 h-20 md:w-44 md:h-44 object-contain drop-shadow-lg select-none"
              />
            </div>
          }
          className="shadow-none bg-transparent hover:shadow-none bottom-[16%] md:bottom-[10%] select-none"
          draggable
        />
      )}
    </>
  );
};

export default HomePage;
